import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, Eye, EyeOff, ShieldCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForcePasswordReset({ onComplete }) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmPassword) { toast.error('Passwords do not match'); return; }

    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      await axios.post(`${API}/auth/change-password`, { new_password: newPassword }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      // Update stored user
      const stored = localStorage.getItem('auth_user');
      if (stored) {
        const u = JSON.parse(stored);
        u.must_change_password = false;
        localStorage.setItem('auth_user', JSON.stringify(u));
      }
      toast.success('Password updated successfully!');
      if (onComplete) onComplete();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to change password');
    }
    setLoading(false);
  };

  return (
    <div className="fpr-overlay" data-testid="force-password-reset">
      <div className="fpr-card">
        <div className="fpr-icon"><Lock size={32} /></div>
        <h2>Change Your Password</h2>
        <p>You're using a temporary password. Please set a new one to continue.</p>
        <form onSubmit={handleSubmit}>
          <div className="fpr-field">
            <label>New Password</label>
            <div className="fpr-input-wrap">
              <input
                type={showPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="At least 6 characters"
                autoFocus
                data-testid="fpr-new-password"
              />
              <button type="button" className="fpr-eye" onClick={() => setShowPassword(p => !p)}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div className="fpr-field">
            <label>Confirm Password</label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={confirmPassword}
              onChange={e => setConfirmPassword(e.target.value)}
              placeholder="Repeat password"
              data-testid="fpr-confirm-password"
            />
          </div>
          <button type="submit" className="fpr-submit" disabled={loading} data-testid="fpr-submit">
            <ShieldCheck size={18} /> {loading ? 'Updating...' : 'Set New Password'}
          </button>
        </form>
      </div>
    </div>
  );
}
